export default {
	heading: {
		headline: 'Articles',
		headlineType: "h2",
		headlineFontSize: '3rem',
		headlineFontWeight: '700',
		headlineStyle: 'freeStyle',
		layoutName: 'product_content_widget',
		subHeadlineFontColor: 'greyDarker',
		subHeadlineFontSize: 'titleSmall',
		subHeadlineFontWeight: 'large',
		titleAlign: 'center',
		titleMargin: '0 0.5rem 2.5rem 0.5rem',
		widgetID: '107',
		widgetName: 'Content Card Template Carousel',
		widgetWidth: '1',
		gtmParameters: {
			event: "trackEventNoEcommerce",
			eventActionClick: "click",
			eventActionView: "view",
			eventCategory: `shop | SHOP Favourites`,
			eventLabelCardClick: `shop | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
			eventLabelHeadlineClick: `shop | headline | {{headline}}`,
			eventLabelView: `shop | SHOP Favourites`,
		},
	},

	data: [{
			cta: 'Read More',
			image: 'https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt4885540b0baf5565/647f0475fe2e120ec84c42a4/Father_s_Day_article_image.png',
			imageSize: {
				desktop: {
					height: '189px',
					width: '100%'
				},
				mobile: {
					height: '202px',
					width: '100%'
				}
			},
			primaryLabel: '',
			subtitle: 'Father’s Day is a day that honors fathers and father figures in our lives. Father’s Day is traditionally celebrated...',
			title: '10 Awesome Father’s Day Gifts from airasia shop',
			url: 'https://www.airasia.com/aa/en/gb/shop/10-awesome-fathers-day-gifts-from-airasia-shop.html'
		},
		{
			cta: 'Read More',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jun/id/SEO-generic-skincare.png',
			imageSize: {
				desktop: {
					height: '189px',
					width: '100%'
				},
				mobile: {
					height: '202px',
					width: '100%'
				}
			},
			primaryLabel: '',
			subtitle: 'Often when you travel, skin is exposed to harsh conditions. From battling piercing heat to dry and dusty conditions...',
			title: '7 best skincare products on airasia shop',
			url: 'https://www.airasia.com/aa/en/gb/shop/7-best-skincare-products-on-airasia-shop.html'
		},
		{
			cta: 'Read More',
			image: 'https://images.contentstack.io/v3/assets/blt5baee87c838aa782/blt275967d3886ef98a/640e8493e35cc90ebcbd3c31/SEO-Page-Landing-Cards-02.jpg',
			imageSize: {
				desktop: {
					height: '189px',
					width: '100%'
				},
				mobile: {
					height: '202px',
					width: '100%'
				}
			},
			primaryLabel: '',
			subtitle: 'The fragrance industry is a multi-billion dollar industry with thousands and thousands of   male, female and even unisex scents available...',
			title: 'Best Perfumes for Men & Women',
			url: 'https://www.airasia.com/aa/en/gb/shop/best-perfumes-for-men-women.html'
		},
		{
			cta: 'Read More',
			image: 'https://images.contentstack.io/v3/assets/blt5baee87c838aa782/bltf234779d3c2ad270/640e84939a3afb6a24ebaabf/SEO-Page-Landing-Cards-01.jpg',
			imageSize: {
				desktop: {
					height: '189px',
					width: '100%'
				},
				mobile: {
					height: '202px',
					width: '100%'
				}
			},
			primaryLabel: '',
			subtitle: 'If you’re thinking of starting a home bar, you’ll need some of the best drinks available on the market...',
			title: '5 Best Alcohols from airasia shop for your Home Bar ',
			url: 'https://www.airasia.com/aa/en/gb/shop/5-best-alcohols-from-airasia-shop-for-your-home-bar.html'
		},
	],
};